import type {PhoneNumberInput} from "@project/sdk/sales";

export const phoneMapper = {
  toSdk: (
    nationalNumber: string,
    regionCode: PhoneNumberInput["regionCode"],
  ): PhoneNumberInput => ({
    nationalNumber,
    regionCode,
  }),
};
